export const getDeletedField = ({ currentNutrient, originNutrient }) => {
  if (!originNutrient) return [];

  const pathNutrient = [];

  originNutrient?.forEach((element) => {
    const isDeletedField = currentNutrient.every(
      (nutrient) => nutrient?.path !== element?.path
    );

    if (isDeletedField) pathNutrient.push(element?.path);
  });

  return pathNutrient;
};
